import React from 'react';
import { motion } from 'framer-motion';
import { LightningIcon, LockIcon, DownloadIcon, CheckIcon } from './Icons';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-primary relative overflow-hidden" data-id="element-94">
      <div className="max-w-4xl mx-auto w-full flex flex-col items-center text-center pt-8 pb-10 md:pt-16 md:pb-16 px-4 md:px-12" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center w-full" data-id="element-96">
          <h1 className="font-playfair font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-7xl leading-tight mb-4 md:mb-6 text-warm-white drop-shadow-lg" data-id="element-97">
            Re-programa tu Cerebro para Atraer y Retener{' '}
            <span className="text-gold" data-id="element-98">Dinero en 21 Días</span>
          </h1>

          <p className="font-inter text-base md:text-xl text-warm-muted mb-8 md:mb-10 max-w-2xl leading-relaxed px-2" data-id="element-99">
            El sistema científico basado en neuroplasticidad y regulación
            somática que elimina el bloqueo financiero desde su raíz biológica.
            No es motivación. Es neurociencia.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full max-w-sm md:max-w-md rounded-2xl overflow-hidden shadow-glow-gold-lg mb-8 md:mb-10 mx-auto" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/7u94iAcYxpEvrfjCrg93F9/IMAGEN_DEL_PRODUCTO.png" alt="El Protocolo RNS - Ebook digital en tablet" className="w-full h-auto object-cover rounded-2xl" data-id="element-101" />
          </motion.div>

          <div className="flex flex-col items-center mb-6 md:mb-8" data-id="element-102">
            <div className="flex items-center gap-4 mb-2" data-id="element-103">
              <span className="text-warm-disabled line-through font-inter text-lg" data-id="element-104">
                Valor $37
              </span>
              <span className="bg-gold text-primary font-bold px-2 py-1 rounded text-sm" data-id="element-105">
                83% OFF
              </span>
            </div>
            <div className="font-playfair font-extrabold text-4xl md:text-5xl text-gold" data-id="element-106">
              $6.39
            </div>
          </div>

          <button onClick={scrollToPricing} className="w-full max-w-lg bg-gold hover:bg-gold-light transition-all text-primary font-inter font-bold text-base md:text-lg px-6 md:px-10 py-4 md:py-5 rounded shadow-glow-gold hover:shadow-glow-gold-lg mb-5 md:mb-6 transform hover:-translate-y-1" data-id="element-107">
            SÍ QUIERO REPROGRAMAR MI CEREBRO AHORA
          </button>

          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-warm-muted text-sm font-inter" data-id="element-108">
            <div className="flex items-center gap-1.5" data-id="element-109">
              <LockIcon className="w-4 h-4" data-id="element-110" /> Pago seguro
            </div>
            <span className="hidden sm:inline text-warm-disabled" data-id="element-111">•</span>
            <div className="flex items-center gap-1.5" data-id="element-112">
              <DownloadIcon className="w-4 h-4" data-id="element-113" /> Descarga inmediata en PDF
            </div>
            <span className="hidden sm:inline text-warm-disabled" data-id="element-114">•</span>
            <div className="flex items-center gap-1.5" data-id="element-115">
              <CheckIcon className="w-4 h-4" data-id="element-116" /> 55 páginas
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}